export const INFO_NAME = 'MyHouse Booking';
export const BUILD_NUMBER = 13;